// extracted by mini-css-extract-plugin
module.exports = {"spinnerBorder":"Spinner_spinnerBorder__1Hmac","spinner":"Spinner_spinner__1gELc"};